import React, { Component } from 'react';
import { func, arrayOf, shape, string, number, bool } from 'prop-types';
import './Tabs.scss';

export default class Tabs extends Component {

  // constructor(props) {
  //   super(props)
  //   const { currentTabIdx } = props

  //   this.state = {
  //     currentTabIdx: currentTabIdx || 0,
  //   }
  // }
   
  className = (currentTabIdx, idx, availableTabs) => {
    let className = 'tab'
    if (currentTabIdx === idx) className += ' current'
    if (idx > availableTabs) className += ' disabled'
    return className
  }

  onClick = (idx, id) => () => {
    const { onClick } = this.props
    // this.setState({ currentTabIdx: idx })
    onClick(id)
  }

  getTitle = (idx, title) => {
    const { showIndex, showTitle } = this.props;
    if (showIndex && showTitle)
      return `${idx}. ${title}`;
    else if (showIndex) {
      return idx;
    } else {
      return title
    }
  }

  render() {
    const { currentTabIdx, availableTabs, tabs } = this.props
    const scale = (tabs && tabs.length) ? 1 / tabs.length : 0
    const sliderStyle = { transform: `translateX(${currentTabIdx * (scale * 100)}%) scaleX(${scale})` }
    // const numberOfAvalableTabs = availableTabs ? availableTabs : tabs.length
    return (
      <ul className="tabs">
        {tabs && tabs.map((tab, idx) => (
          <li
            className={this.className(currentTabIdx, idx, availableTabs)}
            onClick={idx <= availableTabs ? this.onClick(idx, tab.id) : null}
            key={idx}
          >
            {this.getTitle(idx+1, tab.title)}
          </li>
        ))}
        <div style={sliderStyle} className="slider"></div>
      </ul>
    )
  }
}

Tabs.propTypes = {
  showIndex: bool,
  showTitle: bool,
  tabs: arrayOf(shape({
    id: string.isRequired,
    title: string.isRequired,
  })),
  currentTabIdx: number,
  onClick: func
};

Tabs.defaultProps = {
  showIndex: false,
  showTitle: true,
  tabs: [],
  currentTabIdx: 0,
  onClick: () => { }
};